import { FC, memo, useMemo } from 'react';
import { DISPATCHER_ORDER_TIMELINE_STEPS_ICONS } from './configs';
import { StepRender, getOrderTimelineSteps } from './helper';
import { IDispatcherOrderTimelineProps } from './types';
import styles from './DispatcherOrderTimeline.module.css';
import { Flex, Timeline, Tooltip } from 'antd';

export const DispatcherOrderTimeline: FC<IDispatcherOrderTimelineProps> = memo(({ timeline }) => {
	// ! memos
	const currentStepIndex = useMemo(() => {
		const firstItemWithout = timeline.timeline_order.findIndex((t) => !timeline[t]);

		const currentOrderStatusTimeLneStep: number = Math.max(firstItemWithout - 1, -1);

		return currentOrderStatusTimeLneStep;
	}, [timeline]);

	const currentStep = useMemo(() => {
		if (currentStepIndex < 0) return undefined;
		return timeline.timeline_order.at(currentStepIndex);
	}, [currentStepIndex, timeline.timeline_order]);

	const tooltipTimelineItems = useMemo(
		() => {
			if (currentStepIndex < 0) return [];
			return getOrderTimelineSteps(timeline, currentStepIndex);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[currentStepIndex]
	);

	// ! render
	if (!currentStep) return null;

	return (
		<Tooltip
			color='white'
			placement='left'
			title={
				<Timeline
					mode='left'
					items={tooltipTimelineItems}
					className={styles.tooltip_timeline_container}
				/>
			}
		>
			<Flex
				gap={4}
				vertical
				align='center'
				justify='center'
				className={styles.current_timeline_step}
			>
				{DISPATCHER_ORDER_TIMELINE_STEPS_ICONS[currentStep]}

				<StepRender
					value={timeline[currentStep]}
					timeLineKey={currentStep}
					isNextStep={false}
					isCurrentStep={true}
				/>
			</Flex>
		</Tooltip>
	);
});
